import {Mapper} from '@s-ui/domain'

export class HTTPUserAlertsListResponseToUserAlertsValueObjectMapper extends Mapper {
  constructor({config, fromUserAlertRawDataToUserAlertEntityMapper, userAlertsListValueObjectFactory}) {
    super()
    this._config = config
    this._fromUserAlertRawDataToUserAlertEntityMapper = fromUserAlertRawDataToUserAlertEntityMapper
    this._userAlertsListValueObjectFactory = userAlertsListValueObjectFactory
  }

  map = ({data}) => {
    const userAlerts = data.map(this._fromUserAlertRawDataToUserAlertEntityMapper.map)

    return this._userAlertsListValueObjectFactory({
      userAlerts
    })
  }
}
